import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getTierList = async (param) => {
  const baseUrl = `${API_CONSTANTS.TIER}/tier-list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};
export const addTier = async (incomingData) => {
  let payload = {
    data: [...incomingData],
  };
  let responseObj = await dataAccess.post(
    `${API_CONSTANTS.TIER}/default-add`,
    payload
  );

  return responseObj;
};

export const deleteTier = async (id, type) => {
  let url = `${API_CONSTANTS.TIER}/delete-tier?id=${id}&type=${type}`;

  let responseObj = await dataAccess.del(url);
  return responseObj;
};

export const updateTier = async (id, incomingData, type) => {
  let url = '';
  url = `${API_CONSTANTS.TIER}/default-update?defaultTierId=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.put(url, payload);
  return responseObj;
};

export const getTierById = async (id, type) => {
  let url = `${API_CONSTANTS.TIER}/default-detail?defaultTierId=${id}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};
export const getTierMaster = async () => {
  let responseObj = await dataAccess.get(`${API_CONSTANTS.TIER}/tier-master`);
  return responseObj;
};

//festive

export const addFestiveTier = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.post(
    `${API_CONSTANTS.TIER}/festive-add`,

    payload
  );

  return responseObj;
};
export const updateFestiveTier = async (id, incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };
  let responseObj = await dataAccess.put(
    `${API_CONSTANTS.TIER}/festive-update?festiveTierId=${id}`,
    payload
  );

  return responseObj;
};

export const getDefaultTierByMallId = async (id) => {
  let responseObj = await dataAccess.get(
    `${API_CONSTANTS.TIER}/tier-by-default?mallId=${id}`
  );
  return responseObj;
};

export const getFestiveTierById = async (id, type) => {
  let url = `${API_CONSTANTS.TIER}/festive-detail?festiveTierId=${id}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};
